import type { ReactNode } from 'react';
import {
  customerDataQualityContext,
  useCustomerDataQualityCheckout,
  type CustomerDataQualityCheckoutProps
} from './useCustomerDataQualityCheckout';

type Props = CustomerDataQualityCheckoutProps & { children: ReactNode };

/** One report and one sheet for every customer surface under this provider. */
export function CustomerDataQualityProvider({ children, ...props }: Props) {
  const gate = useCustomerDataQualityCheckout(props);
  return (
    <customerDataQualityContext.Provider value={gate}>
      {children}
      {gate.dialog}
    </customerDataQualityContext.Provider>
  );
}
